/**
 * V1 exposure for Taxonomy Designer (G-1d / X-3).
 *
 * Customers see Designer only when `manage-category-taxonomy-designer` is on
 * in their sidebar config. Internal users keep access everywhere, so rollout
 * does not depend on flipping every tenant. The sidebar link (DropDownNav)
 * and the page URL (TaxonomyDesignerGate) both apply this rule; the Manage
 * Categories tab that also did is gone.
 * P0.7 (server allowlist / kill switch) is a later gate, not this one.
 */

export const TAXONOMY_DESIGNER_SIDEBAR_KEY = 'manage-category-taxonomy-designer';

function flagOn(value: unknown): boolean {
  return value === true || value === 'true' || value === 1;
}

export function isTaxonomyDesignerExposed(opts: {
  sidebarLinkConfig?: Record<string, unknown> | null;
  isInternalUser?: boolean;
}): boolean {
  if (opts.isInternalUser) return true;
  return flagOn(opts.sidebarLinkConfig?.[TAXONOMY_DESIGNER_SIDEBAR_KEY]);
}
